import script from "./Notification.vue?vue&type=script&lang=tsx"
export * from "./Notification.vue?vue&type=script&lang=tsx"

import "./Notification.vue?vue&type=style&index=0&id=6df5a110&lang=scss&scoped=true"

import exportComponent from "/builds/dc/siemens.fm/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6df5a110"]])

export default __exports__